<template>
  <div class="national-main" :style="`padding-top:${barHeight}px`">
    <van-nav-bar class="van-bar" left-arrow @click-left="closeWeb" @click-right="handleToRule">
      <template #left>
        <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
      </template>
      <template #right>
        <img class="right-nav" src="@/assets/packageAssets/common/rules02.png" alt="" />
      </template>
    </van-nav-bar>

    <div class="national-con" :style="{ 'margin-top': `-${barHeight + 46}px` }">
      <div class="national-head">
        <img class="head-img-back" src="./images/main-bg.png" />

        <div class="head-img">
          <img v-if="$i18n.locale === 'es'" :src="getMatchTitle('tit-bg-es')" />
          <img v-else-if="$i18n.locale === 'pt'" :src="getMatchTitle('tit-bg-pt')" />
          <img v-else :src="getMatchTitle('tit-bg-en')" />
        </div>
      </div>

      <div class="main-con">
        <div class="act-date">
          <template v-if="actInfo">
            <div v-if="!actInfo.started" class="act-enddate">
              {{ $t('lang.ActCommon.k010') }}:
              <i>{{ countdownResult.hours }}:{{ countdownResult.minutes }}:{{ countdownResult.seconds }}</i>
            </div>
            <div v-else class="act-enddate">
              {{ $t('lang.ActCommon.k011') }}:
              <i>{{ countdownResult.days }}:{{ countdownResult.hours }}:{{ countdownResult.minutes }}:{{ countdownResult.seconds }}</i>
            </div>
          </template>

          <div style="height: 12px"></div>
          <div class="act-range">{{ mexActStartTime }} - {{ mexActEndTime }}</div>
        </div>

        <div v-if="actInfo && !!actInfo.started" class="points-rank">
          <div class="pr-item">
            <div>{{ $t('lang.ActCommon.k020') }}</div>
            <div v-if="actInfo">{{ actInfo.score || 0 }}</div>
          </div>
          <div style="width: 15px"></div>
          <div class="pr-item">
            <div>{{ $t('lang.ActCommon.k021') }}</div>
            <template v-if="actInfo">
              <div v-if="!actInfo.rank">--</div>
              <div v-else>{{ actInfo.rank }}</div>
            </template>
          </div>
        </div>

        <div class="part-block">
          <div class="part-head">{{ $t('lang.ActCommon.k012') }}</div>
          <div v-if="actInfo && !!actInfo.started" class="part-tips">{{ $t('lang.ActCommon.k036') }}</div>
          <div v-else class="part-tips">{{ $t('lang.ActCommon.k023') }}</div>
          <div class="national-gift">
            <div class="gift-round">
              <div class="gift-cost">+1 {{ $t('lang.ActCommon.k046') }}</div>
              <img src="@/assets/packageAssets/common/Balloons.png" alt="" />
              <div class="gift-name">{{ $t('lang.HolidayBR.k003') }}</div>
            </div>
            <div class="gift-round">
              <div class="gift-cost">+3 {{ $t('lang.ActCommon.k046') }}</div>
              <img src="@/assets/packageAssets/common/Ring.png" alt="" />
              <div class="gift-name">{{ $t('lang.ActCommon.k013') }}</div>
            </div>
            <div class="gift-round">
              <div class="gift-cost">+5 {{ $t('lang.ActCommon.k046') }}</div>
              <img src="@/assets/packageAssets/common/Rose.png" alt="" />
              <div class="gift-name">{{ $t('lang.HolidayBR.k001') }}</div>
            </div>
            <div class="gift-round">
              <div class="gift-cost">+15 {{ $t('lang.ActCommon.k046') }}</div>
              <img src="@/assets/packageAssets/common/Kiss.png" alt="" />
              <div class="gift-name">{{ $t('lang.ActCommon.k052') }}</div>
            </div>
            <div class="gift-round">
              <div class="gift-cost">+50 {{ $t('lang.ActCommon.k046') }}</div>
              <img src="@/assets/packageAssets/common/Treasure.png" alt="" />
              <div class="gift-name">{{ $t('lang.ActCommon.k051') }}</div>
            </div>
          </div>
        </div>

        <div class="part-block">
          <div class="part-head">{{ $t('lang.ActCommon.k017') }}</div>
          <div class="part-tips">{{ $t('lang.ActCommon.k018') }}</div>
          <div class="national-reward">
            <div class="national-item">
              <div class="reward-num">No.1</div>
              <div class="reward-coins">
                1000
                <img class="coins-icon" :src="getMatchImg('coin')" />
              </div>
            </div>
            <div class="national-item">
              <div class="reward-num">No.2</div>
              <div class="reward-coins">
                600
                <img class="coins-icon" :src="getMatchImg('coin')" />
              </div>
            </div>
            <div class="national-item">
              <div class="reward-num">No.3</div>
              <div class="reward-coins">
                300
                <img class="coins-icon" :src="getMatchImg('coin')" />
              </div>
            </div>
            <div class="national-item">
              <div class="reward-num">No.4-10</div>
              <div class="reward-coins">
                80
                <img class="coins-icon" :src="getMatchImg('coin')" />
              </div>
            </div>
          </div>

          <div class="btn-block" v-if="actInfo && !!actInfo.started">
            <div class="national-btn" @click="handleToRank">{{ $t('lang.ActCommon.k019') }}</div>
          </div>
        </div>

        <div v-if="actInfo && !actInfo.started" class="part-block">
          <div class="part-head">{{ $t('lang.ActCommon.k094') }}</div>
          <div class="part-tips">
            {{ $t('lang.ActCommon.k039') }}
            <i v-if="actInfo && !actInfo.started">{{ $t('lang.ActCommon.k022') }}</i>
          </div>
          <div class="national-props" style="margin-top: 0">
            <!-- Lucky Joy  -->
            <template v-if="packageName !== 'echo'">
              <div class="national-props-item">
                <div>
                  <img src="./images/avatar-bar.png" />
                </div>
                <div>{{ $t('lang.HolidayBR.k004') }}</div>
              </div>
              <div style="width: 20px"></div>
            </template>

            <!-- super-chat-pass  -->
            <div class="national-props-item">
              <div>
                <img :src="getMatchImg('super-chat-pass')" />
              </div>
              <div>{{ $t('lang.ActCommon.k005') }}</div>
            </div>
          </div>
          <div class="national-props">
            <!-- video-pass  -->
            <div class="national-props-item">
              <div>
                <img :src="getMatchImg('video-pass')" />
              </div>
              <div>{{ $t('lang.ActCommon.k088') }}</div>
            </div>
            <div style="width: 20px"></div>

            <!-- coupon  -->
            <div class="national-props-item">
              <div>
                <img :src="getMatchImg('coupon')" />
              </div>
              <div>{{ $t('lang.BaseCommon.k038') }}</div>
            </div>
          </div>
        </div>

        <div v-if="actInfo && !!actInfo.started" class="part-block">
          <div class="part-head">{{ $t('lang.ActCommon.k094') }}</div>
          <div class="part-tips">
            <template v-if="actInfo && !actInfo.started">{{ $t('lang.ActCommon.k022') }}</template>
            <template v-else>{{ $t('lang.ActCommon.k054') }}</template>
          </div>
          <div v-if="actInfo.signTask" class="task-item">
            <!-- prettier-ignore -->
            <span class="task-item-tit">{{ $t('lang.ActCommon.k047') }} ({{ actInfo.signTask.proc }}/<i>{{ actInfo.signTask.target }}</i>)</span>
            <div class="task-item-reward">
              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('super-chat-pass')" /></div>
                <div class="item-gift-num">x1</div>
              </div>
            </div>
            <div v-if="actInfo.signTask.state == 0" class="task-item-btn" @click="handleSign">Check in</div>
            <div v-if="actInfo.signTask.state == 1" class="task-item-btn disable">
              <template v-if="leftClassObj && leftClassObj.countdownResult">
                {{ leftClassObj.countdownResult.hours }}:{{ leftClassObj.countdownResult.minutes }}:{{ leftClassObj.countdownResult.seconds }}
              </template>
            </div>
          </div>

          <div v-if="actInfo.send1Task" class="task-item">
            <!-- prettier-ignore -->
            <span class="task-item-tit">{{ $t('lang.ActCommon.k038') }} ({{ actInfo.send1Task.proc }}/<i>{{ actInfo.send1Task.target }}</i>)</span>
            <div class="task-item-reward">
              <!-- 头像框 -->
              <template v-if="packageName !== 'echo'">
                <div class="task-item-gift">
                  <div class="item-gift-img"><img src="./images/avatar-bar.png" /></div>
                  <div class="item-gift-num">x1</div>
                </div>
                <div class="task-item-gap"></div>
              </template>
              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('video-pass')" /></div>
                <div class="item-gift-num">x2</div>
              </div>
            </div>
            <div v-if="actInfo.send1Task.state == 0" class="task-item-btn" @click="handleToChatList">{{ $t('lang.ActCommon.k048') }}</div>
            <div v-if="actInfo.send1Task.state == 1" class="task-item-btn" @click="handleClaim(1)">{{ $t('lang.ActCommon.k086') }}</div>
            <div v-if="actInfo.send1Task.state == 2" class="task-item-btn disable">
              <template v-if="leftClassObj && leftClassObj.countdownResult">
                {{ leftClassObj.countdownResult.hours }}:{{ leftClassObj.countdownResult.minutes }}:{{ leftClassObj.countdownResult.seconds }}
              </template>
            </div>
          </div>

          <div v-if="actInfo.send5Task" class="task-item">
            <!-- prettier-ignore -->
            <span class="task-item-tit">{{ $t('lang.ActCommon.k052') }} ({{ actInfo.send5Task.proc }}/<i>{{ actInfo.send5Task.target }}</i>)</span>
            <div class="task-item-reward">
              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('super-chat-pass')" /></div>
                <div class="item-gift-num">x2</div>
              </div>

              <div class="task-item-gap"></div>

              <template v-if="packageName !== 'echo'">
                <div class="task-item-gift">
                  <div class="item-gift-img"><img src="./images/avatar-bar.png" /></div>
                  <div class="item-gift-num">x2</div>
                </div>

                <div class="task-item-gap"></div>
              </template>

              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('video-pass')" /></div>
                <div class="item-gift-num">x5</div>
              </div>

              <div class="task-item-gap"></div>

              <div class="task-item-gift">
                <div class="item-gift-img"><img :src="getMatchImg('coupon')" /></div>
                <div class="item-gift-num">x1</div>
              </div>
            </div>
            <div v-if="actInfo.send5Task.state == 0" class="task-item-btn" @click="handleToChatList">Start Now</div>
            <div v-if="actInfo.send5Task.state == 1" class="task-item-btn" @click="handleClaim(5)">Claim</div>
            <div v-if="actInfo.send5Task.state == 2" class="task-item-btn disable">
              <template v-if="leftClassObj && leftClassObj.countdownResult">
                {{ leftClassObj.countdownResult.hours }}:{{ leftClassObj.countdownResult.minutes }}:{{ leftClassObj.countdownResult.seconds }}
              </template>
            </div>
          </div>
        </div>

        <div class="btn-block" v-if="actInfo && !actInfo.started">
          <div class="national-btn" @click="handleGotIt">{{ $t('lang.BaseCommon.k039') }}</div>
        </div>
      </div>
    </div>

    <div v-if="showSuccess" class="act-mask">
      <div class="dia-bg">
        <div class="con-block">
          <div class="gifts-tit">{{ $t('lang.ActCommon.k089') }}!</div>
          <div v-if="showSuccess === 1" class="gifts">
            <div>
              <div class="img-wrap">
                <img :src="getMatchImg('super-chat-pass')" alt="" />
              </div>
              <div class="rewards-name">{{ $t('lang.HolidayBR.k002') }}</div>
              <div class="rewards-count">x1</div>
            </div>
          </div>

          <div v-if="showSuccess === 2" class="gifts">
            <template v-if="packageName !== 'echo'">
              <div>
                <div class="img-wrap">
                  <img src="./images/avatar-bar.png" alt="" />
                </div>
                <div class="rewards-name">{{ $t('lang.HolidayBR.k004') }}</div>
                <div class="rewards-count">x1</div>
              </div>
              <div class="gift-gap"></div>
            </template>

            <div>
              <div class="img-wrap">
                <img :src="getMatchImg('video-pass')" alt="" />
              </div>
              <div class="rewards-name">{{ $t('lang.ActCommon.k088') }}</div>
              <div class="rewards-count">x2</div>
            </div>
          </div>

          <div v-if="showSuccess === 3" class="gifts">
            <div>
              <div class="img-wrap">
                <img :src="getMatchImg('super-chat-pass')" alt="" />
              </div>
              <div class="rewards-name">{{ $t('lang.HolidayBR.k002') }}</div>
              <div class="rewards-count">x2</div>
            </div>
            <div class="gift-gap"></div>

            <template v-if="packageName !== 'echo'">
              <div>
                <div class="img-wrap">
                  <img src="./images/avatar-bar.png" alt="" />
                </div>
                <div class="rewards-name">{{ $t('lang.HolidayBR.k004') }}</div>
                <div class="rewards-count">x2</div>
              </div>
              <div class="gift-gap"></div>
            </template>

            <div>
              <div class="img-wrap">
                <img :src="getMatchImg('video-pass')" alt="" />
              </div>
              <div class="rewards-name">{{ $t('lang.ActCommon.k088') }}</div>
              <div class="rewards-count">x5</div>
            </div>
            <div class="gift-gap"></div>

            <div>
              <div class="img-wrap">
                <img :src="getMatchImg('coupon')" alt="" />
              </div>
              <div class="rewards-name">{{ $t('lang.ActCommon.k088') }}</div>
              <div class="rewards-count">x1</div>
            </div>
          </div>
          <div class="gifts-confirm" @click="showSuccess = 0">
            <div>{{ $t('lang.ActCommon.k100') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { holidayActBaseInfoBr, holidayDaySignBr, holidayDayClaimBr } from './apidir/api.js'

import countDown from '@/mixin/count-down.js'
import CountDownClass from '@/utils/count-down.js'

// en
import vavaTitBgEn from './images/vava/bg-en.png'
import echoTitBgEn from './images/echo/bg-en.png'
import joychatTitBgEn from './images/joychat/bg-en.png'

// es
import vavaTitBgEs from './images/vava/bg-es.png'
import echoTitBgEs from './images/echo/bg-es.png'
import joychatTitBgEs from './images/joychat/bg-es.png'

// pt
import vavaTitBgPt from './images/vava/bg-pt.png'
import echoTitBgPt from './images/echo/bg-pt.png'
import joychatTitBgPt from './images/joychat/bg-pt.png'

export default {
  mixins: [countDown],
  data() {
    return {
      actInfo: null,
      showSuccess: 0,
      mexActStartTime: '',
      mexActEndTime: '',
      // 当天倒计时相关
      leftClassObj: null,
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    handleToRule() {
      this.$router.push({ path: '/holiday-rules-male-br', query: { from: 'holiday-main-male-br' } })
    },
    handleToRank() {
      this.$router.push({ path: '/holiday-rank-male-br', query: { from: 'holiday-main-male-br' } })
    },
    handleToChatList() {
      this.appAction('open_session_page')
    },
    handleGotIt() {
      this.closeWeb()
    },
    getMatchTitle(imgname) {
      const imgsMap = {
        'tit-bg-en': {
          vava: vavaTitBgEn,
          echo: echoTitBgEn,
          joychat: joychatTitBgEn,
        },
        'tit-bg-es': {
          vava: vavaTitBgEs,
          echo: echoTitBgEs,
          joychat: joychatTitBgEs,
        },
        'tit-bg-pt': {
          vava: vavaTitBgPt,
          echo: echoTitBgPt,
          joychat: joychatTitBgPt,
        },
      }

      // 按包名判断
      const appName = this.getAppName()
      if (this.appNameFlag('vava', appName)) {
        return imgsMap[imgname]['vava']
      }
      if (this.appNameFlag('echo', appName)) {
        return imgsMap[imgname]['echo']
      }
      if (this.appNameFlag('joychat', appName)) {
        return imgsMap[imgname]['joychat']
      }
      if (this.appNameFlag('joylink', appName)) {
        return imgsMap[imgname]['joylink']
      }
      if (this.appNameFlag('goparty', appName)) {
        return imgsMap[imgname]['goparty']
      }
    },
    // 获取数据
    fetchData() {
      holidayActBaseInfoBr().then((resData) => {
        this.actInfo = resData || null

        if (this.actInfo.startTimestamp) {
          this.mexActStartTime = this.handleMoment(this.actInfo.startTimestamp, 'YYYY/MM/DD HH:mm:ss')
        }
        if (this.actInfo.endTimestamp) {
          this.mexActEndTime = this.handleMoment(this.actInfo.endTimestamp, 'YYYY/MM/DD HH:mm:ss')
        }

        // 初始化倒计时
        if (resData.countdown) {
          this.initCountDown(resData.countdown, !!this.actInfo.started)
        }

        if (resData.dailyCountdown) {
          this.leftClassObj = new CountDownClass()
          this.leftClassObj.initCountDown(resData.dailyCountdown, 'HMS')
        }
      })
    },
    handleSign() {
      holidayDaySignBr().then((resData) => {
        if (resData && resData.data) {
          this.showSuccess = 1
          this.fetchData()
        }
      })
    },
    handleClaim(arg) {
      const idMap = {
        1: 2,
        5: 3,
      }
      holidayDayClaimBr({ taskId: arg }).then((resData) => {
        if (resData && resData.data) {
          this.showSuccess = idMap[arg]
          this.fetchData()
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.national-main {
  width: 100%;
  min-height: 100vh;
  background: #20a438;

  .national-con {
    .national-head {
      width: 100%;
      position: relative;
      .head-img-back {
        width: 100%;
      }
      .head-img {
        position: absolute;
        top: 75px;
        z-index: 9;
        padding-top: 10px;
        width: 100%;
        img {
          display: block;
          width: 100%;
        }
      }
    }

    .main-con {
      position: relative;
      overflow: hidden;
      padding-bottom: 79px;
      margin-top: -290px;

      .act-date {
        width: 355px;
        height: 87px;
        margin: 0 auto;
        border-radius: 12px;
        border: 0.5px solid rgba(255, 255, 255, 0.5);
        background: rgba(5, 107, 0, 0.8);
        backdrop-filter: blur(10.873126983642578px);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .act-enddate {
          font-family: 'TikTokSans-Regular';
          font-weight: 600;
          font-size: 17px;
          color: #ffffff;
          line-height: 22px;
          text-align: right;
          i {
            color: #ffcf00;
          }
        }
        .act-range {
          font-family: 'TikTokSans-Regular';
          font-weight: 400;
          font-size: 15px;
          color: #ffffff;
          line-height: 20px;
          text-align: right;
        }
      }

      .points-rank {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 16px;
        .pr-item {
          width: 170px;
          height: 66px;
          padding: 10px;
          background: #f4faf2;
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          div:nth-child(1) {
            font-family: 'TikTokSans-Regular';
            font-weight: 400;
            font-size: 15px;
            color: #076229;
            line-height: 20px;
          }
          div:nth-child(2) {
            font-family: 'TikTokSans-Regular';
            font-weight: bold;
            font-size: 20px;
            color: #076229;
            line-height: 24px;
          }
        }
      }

      .part-block {
        width: 355px;
        min-height: 250px;
        margin: 16px auto 0;
        padding-bottom: 24px;
        background: #f4faf2;
        border-radius: 12px;
        .part-head {
          width: 355px;
          background: #feffae;
          border-radius: 12px 12px 0px 0px;
          font-family: 'TikTokSans-Regular';
          font-size: 17px;
          color: #076229;
          line-height: 42px;
          font-weight: 600;
          text-align: center;
        }
        .part-tips {
          width: 100%;
          padding: 16px;
          font-family: 'TikTokSans-Regular';
          font-weight: 400;
          font-size: 15px;
          color: #576f60;
          line-height: 20px;
          font-style: normal;
        }
        .national-gift {
          width: 100%;
          min-height: 30px;
          margin: 10px auto 16px;
          padding: 0 10px;
          display: flex;
          align-items: flex-start;
          justify-content: space-evenly;
          .gift-round {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .gift-cost {
              background: #4dab00;
              border-radius: 19px;
              padding: 2px 4px;
              min-width: 36px;
              font-family: 'TikTokSans-Regular';
              font-weight: 600;
              font-size: 8px;
              color: #ffffff;
              line-height: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            img {
              width: 40px;
              height: 40px;
              margin-top: 6px;
            }
            .gift-name {
              font-family: 'TikTokSans-Regular';
              font-weight: 400;
              font-size: 12px;
              color: #547a6c;
              line-height: 16px;
              margin-top: 14px;
              text-align: center;
            }
          }
        }
        .national-reward {
          width: 100%;
          padding: 0 16px;
          min-height: 116px;
          margin: 0 auto;

          .national-item {
            font-family: 'TikTokSans-Regular';
            font-weight: 400;
            font-size: 15px;
            color: #295948;
            line-height: 20px;
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
            .reward-coins {
              display: flex;
              align-items: center;
              font-weight: bold;
              .coins-icon {
                width: 16px;
                height: 16px;
                margin-left: 4px;
              }
            }
          }
        }
        .national-props {
          display: flex;
          margin-top: 16px;
          padding: 0 60px;
          .national-props-item {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            div {
              &:nth-child(1) {
                width: 44px;
                height: 44px;
                padding: 4px;
                border-radius: 8px;
                background: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                  width: 100%;
                }
              }
              &:nth-child(2) {
                line-height: 20px;
                font-family: 'TikTokSans-Regular';
                font-weight: 500;
                font-size: 12px;
                text-align: center;
                color: #547a6c;
                margin-top: 6px;
              }
              &:nth-child(3) {
                font-family: 'TikTokSans-Regular';
                font-weight: 500;
                font-size: 12px;
                color: #547a6c;
                line-height: 20px;
                margin-top: 6px;
              }
            }
          }
        }
        .task-item {
          padding: 0 16px;
          margin-bottom: 20px;
          position: relative;
          .task-item-tit {
            color: #576f60;
            font-family: 'TikTokSans-Regular';
            font-size: 15px;
            i {
              color: #a4a9bd;
            }
          }
          .task-item-reward {
            margin-top: 6px;
            display: flex;
            align-items: center;
            .task-item-gap {
              width: 10px;
            }
            .task-item-gift {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              .item-gift-img {
                border-radius: 6px;
                width: 38px;
                height: 38px;
                background: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                  width: 30px;
                }
              }
              .item-gift-num {
                margin-top: 4px;
                color: #295948;
                font-family: 'TikTokSans-Regular';
                font-size: 12px;
                font-style: italic;
                font-weight: 700;
              }
            }
          }
          .task-item-btn {
            position: absolute;
            top: 50%;
            right: 16px;
            transform: translateY(-50%);

            color: #11470e;
            text-align: center;
            font-family: 'TikTokSans-Regular';
            font-size: 16px;
            font-weight: 600;
            line-height: 16px;

            border-radius: 30px;
            background: #ffec00;
            padding: 10px 12px;
          }
          .task-item-btn.disable {
            background: #edeef2;
            color: #a4a9bd;
            font-weight: 400;
          }
        }
      }
      .task-block {
        padding: 0 16px;
        .part-tips-b {
          font-family: 'TikTokSans-Regular';
          font-weight: 500;
          font-size: 17px;
          color: #ffffff;
          line-height: 22px;
          margin-top: 32px;
          text-align: left;
        }
        .part-task {
          margin-top: 13px;
          font-family: 'TikTokSans-Regular';
          font-weight: 400;
          font-size: 15px;
          color: #ffffff;
          line-height: 20px;
          display: flex;
          justify-content: space-between;
        }
      }

      .btn-block {
        display: block;
        width: 100%;
        margin: 30px auto 8px;
        text-align: center;
        .national-btn {
          min-width: 275px;
          display: inline-block;
          padding: 0 15px;
          background: #ffec00;
          border-radius: 27px;
          font-family: 'TikTokSans-Regular';
          font-weight: 500;
          font-size: 17px;
          color: #11470e;
          line-height: 42px;
          text-align: center;
          &.btn-disable {
            color: #edeef2;
            background: #a4a9bd;
          }
        }
      }
    }
  }
}

.act-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;

  .dia-bg {
    width: 315px;
    border-radius: 16px;
    background: linear-gradient(180deg, #84ef98 0%, #deffe4 100%);

    .con-block {
      width: 315px;
      border-radius: 16px;
      background: url(./images/dia-bg.png) top left / 100% auto no-repeat;
      padding: 35px 30px 30px;

      .gifts-tit {
        font-family: 'TikTokSans-Regular';
        font-weight: normal;
        font-size: 20px;
        color: #004700;
        line-height: 20px;
        text-align: center;
        font-weight: bold;
      }

      .gifts {
        margin-top: 24px;
        margin-bottom: 20px;
        width: 100%;
        padding: 16px;
        border-radius: 8px;
        border: 1px solid #fffad7;
        background: linear-gradient(180deg, rgba(32, 164, 56, 0.2) 0%, rgba(241, 255, 48, 0.2) 100%);
        box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1) inset;

        display: flex;
        align-items: center;
        justify-content: center;

        .gift-gap {
          width: 12px;
        }

        & > div {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .img-wrap {
            width: 40px;
            height: 40px;
            padding: 5px;
            border-radius: 8px;
            background: #ffffff;
            img {
              width: 100%;
            }
          }
          .rewards-name {
            font-family: 'TikTokSans-Regular';
            font-weight: 400;
            font-size: 12px;
            color: #547a6c;
            line-height: 22px;
            margin-top: 4px;
            text-align: center;
          }
          .rewards-count {
            font-family: 'TikTokSans-Regular';
            font-weight: bold;
            font-size: 17px;
            color: #295948;
            line-height: 22px;
            font-style: italic;
            margin-top: 2px;
          }
        }
      }
      .gifts-confirm {
        width: 255px;
        line-height: 40px;
        padding: 10px;
        border-radius: 30px;
        background: #ffec00;

        font-family: 'Inter-Regular';
        font-size: 20px;
        font-weight: bold;
        color: #11470e;
        line-height: 20px;
        text-align: center;
      }
    }
  }
}
</style>
